import React, { forwardRef } from 'react';
import * as S from './styled';

export const FlexBox = forwardRef(
  (
    {
      alignItems = 'start',
      flexDirection = 'row',
      justifyContent = 'start',
      mobileFirst = true,
      responsive = [],
      children,
      ...rest
    },
    ref
  ) => (
    <S.Flex
      ref={ref}
      alignItems={alignItems}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      mobileFirst={mobileFirst}
      {...rest}
    >
      {children}
    </S.Flex>
  )
);
